import React from 'react';
import CollapsibleContainer from '@/components/collapsible-container';
import styles from './BriefSection.module.scss';

interface BriefSectionProps {
  title: string;
  children: React.ReactNode;
  testID?: string;
}

function BriefSection({
  title,
  children,
  testID = 'brief-section',
}: BriefSectionProps) {
  return (
    <CollapsibleContainer
      testID={testID}
      headerLabel={title}
      headerClassName={styles.header}
      className={styles.container}
      initialIsOpen
    >
      <div className={styles.content}>{children}</div>
    </CollapsibleContainer>
  );
}

export default BriefSection;
